export default __webpack_public_path__ + "static/media/p3-img.b96c70a4.png";